import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-lex-tag-button',
  templateUrl: './lex-tag-button.component.html',
  styleUrls: ['./lex-tag-button.component.scss'],
  standalone: false,
})
export class LexTagButtonComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  @Input() type: 'addable' | 'deletable' | 'language' | 'route' | 'manual' | 'manual-etc' | 'small';
  @Input() tooltip: string;
  @Input() matIcon: string;
  @Input() svgIcon: string;
  @Input() iconPlacement: 'left' | 'right';

  @Output() click = new EventEmitter<Event>();

  constructor() {}

  ngOnInit() {
    if (this.type) {
      const matIconOverride = this.matIcon;
      const svgIconOverride = this.svgIcon;
      const placementOverride = this.iconPlacement;

      switch (this.type) {
        case 'addable':
          this.matIcon = 'add';
          this.iconPlacement = 'left';
          break;
        case 'route':
          this.svgIcon = 'config-route';
          this.iconPlacement = 'left';
          break;
        case 'small':
          this.matIcon = 'power_settings_new';
          this.iconPlacement = 'left';
          break;
        case 'deletable':
          this.matIcon = 'clear';
          this.iconPlacement = 'right';
          break;
      }

      this.matIcon = matIconOverride || this.matIcon;
      this.svgIcon = svgIconOverride || this.svgIcon;
      this.iconPlacement = placementOverride || this.iconPlacement;
    }
  }

  onButtonClicked($event) {
    this.click.emit($event);
  }
}
